<template>
  <div class="covenants-page">
    <header class="page-head">
      <div class="container">
        <h1 class="page-head__title">Convênios</h1>
        <p class="page-head__lead">
          Empresas e serviços com condições especiais para os associados do sindicato.
        </p>
      </div>
    </header>

    <div class="container covenants-page__body">
      <p v-if="covenantsHome.length === 0" class="covenants-page__status" role="status">
        Carregando convênios…
      </p>

      <ul v-else class="covenants-page__grid">
        <li v-for="card in covenantsHome" :key="card.id">
          <router-link :to="{ path: `/post/covenants/${card.id}` }" class="covenant-card">
            <span class="covenant-card__frame">
              <img :src="card.url" :alt="card.title" class="covenant-card__image" loading="lazy" />
            </span>
            <p v-if="card.category" class="covenant-card__category">{{ card.category }}</p>
            <h2 class="covenant-card__title">{{ card.title }}</h2>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import covenantsService from '../../../../service/covenantsService'

export default {
  name: "covenants",
  metaInfo: {
    title: "SEEB | Convênios",
    meta: [
      { name: 'description', content: 'Nossos convênios' }
    ]
  },
  methods: {
    getCovenants() {
      covenantsService.get({}).then(res => {
        this.covenantsHome = res.data.map(covenants => ({
          id: covenants.id,
          title: covenants.title,
          category: covenants.category,
          date: new Date(covenants.created_at).toLocaleDateString("pt-BR"),
          url: covenants.path_img_card
        }));
      });
    }
  },
  mounted() {
    this.getCovenants();
  },
  data() {
    return {
      covenantsHome: []
    };
  }
};
</script>

<style lang="scss" scoped>
.covenants-page {
  padding-bottom: var(--section);

  &__body {
    padding-top: clamp(40px, 5vw, 64px);
  }

  &__status {
    color: var(--c-muted);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 40px 32px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @media (max-width: 1023px) {
    &__grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 599px) {
    &__grid {
      grid-template-columns: 1fr;
      gap: 32px;
    }
  }
}

.covenant-card {
  display: block;
  color: inherit;
  text-decoration: none;

  &__frame {
    display: block;
    aspect-ratio: calc(16 / 10);
    border-radius: var(--radius);
    overflow: hidden;
    background: #eef2f7;
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 400ms var(--ease);
  }

  &__category {
    margin: 16px 0 6px;
    font-size: var(--fs-meta);
    font-weight: 600;
    color: var(--c-navy-deep);
  }

  &__title {
    margin: 0;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: var(--fs-h4);
    line-height: 1.25;
    color: var(--c-navy);
    text-decoration: underline;
    text-decoration-color: transparent;
    text-underline-offset: 5px;
    transition: text-decoration-color 160ms var(--ease);
  }

  &:hover &__image {
    transform: scale(1.02);
  }

  &:hover &__title {
    text-decoration-color: currentColor;
  }
}
</style>
